import clsx from 'clsx';
import { SharedButtonProps } from '../../types';
import { ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon } from '@heroicons/react/24/solid';
import './button.css';

export default function SharedButton({
  id,
  children,
  onClick,
  className = '',
  type = 'button',
  size = 'sm',
  variant = 'primary',
  iconLeft,
  iconRight,
  disabled = false,
  arrow = 'none',
  style = {},
  title = '',
  weight = 'xl',
  iconMargin = 'mr-2',
  ...rest
}: SharedButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center';

  const sizeStyles = {
    xxs: 'button-xxs',
    xs: 'text-xs px-1 py-1',
    sm: 'text-sm px-4 py-1',
    md: 'text-base px-6 py-2',
    lg: 'text-lg px-5 py-3',
  }[size];

  const weightStyles = {
    sm: 'font-light',
    md: 'font-medium',
    lg: 'font-semibold',
    xl: 'font-bold',
  }[weight];

  const variantStyles = {
    primary: 'btn-primary-pink',
    secondary: 'btn-secondary-blue',
    gradient: 'btn-primary-pink',
    terciary: 'btn-terciary-gray',
    secondaryOutline: 'btn-secondary-outline-blue',
    primaryOutline: 'btn-primary-outline-pink',
    secondaryText: 'btn-secondary-text',
    ghost: 'btn-ghost',
  }[variant];

  const arrowIcon = {
    up: <ArrowUpIcon className="w-4 h-4 ml-1" />,
    down: <ArrowDownIcon className="w-4 h-4 ml-1" />,
    right: <ArrowRightIcon className="w-4 h-4 ml-1" />,
    left: <ArrowLeftIcon className="w-4 h-4 ml-1" />,
    none: null,
  }[arrow];

  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      title={title}
      {...rest}
      className={clsx(
        baseStyles,
        sizeStyles,
        variantStyles,
        weightStyles,
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    >
      {iconLeft && <span className={iconMargin}>{iconLeft}</span>}
      {children}
      {iconRight && <span className="ml-2">{iconRight}</span>}
      {arrowIcon}
    </button>
  );
}
